import { render, staticRenderFns } from "./saveBlog.vue?vue&type=template&id=4a5627ba&scoped=true&"
import script from "./saveBlog.vue?vue&type=script&lang=js&"
export * from "./saveBlog.vue?vue&type=script&lang=js&"
import style0 from "./saveBlog.vue?vue&type=style&index=0&id=4a5627ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5627ba",
  null
  
)

export default component.exports